import { Button, Icon, Text } from "components/common";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { UserAvatar } from "../userListRow";
import { getUserProfilePath } from "constants/app-paths";
import styles from "./index.module.less";

const ICONS = { quiz: "MdOutlineQuiz", study: "AiOutlineBook", bookmark: "LuBookmark", share: "BsShare", follow: "FiUsers", activity: "BiDetail" };

const fallbackAction = (item) => {
  if (item.type === "quiz_completed" && item.metadata?.scriptId) return { label: "View script", path: `/scripts/${item.metadata.scriptId}` };
  if (item.object_type === "script") return { label: "Open script", path: `/scripts/${item.object_id}` };
  if (item.object_type === "quiz") return { label: "Go to tests", path: "/tests" };
  if (item.object_type === "study_session") return { label: "Open sessions", path: "/studysessions" };
  return null;
};

const FeedItem = ({ item }) => {
  const navigate = useNavigate();
  if (!item) return null;
  const actorName = item.actor?.name || "Someone";
  const fallback = fallbackAction(item);
  const action = item.deepLink ? { label: fallback?.label || "Open", path: item.deepLink } : fallback;
  const metadata = item.metadata || {};
  const hasResource = item.thumbnail || (item.type === "content_shared" && item.object_type === "script");
  const goToActor = () => item.actor?.user_code && navigate(getUserProfilePath(item.actor.user_code));

  return (
    <article className={styles.activityItem}>
      <div className={styles.timelineMarker} aria-hidden="true"><Icon icon={ICONS[item.icon] || ICONS.activity} size={15} /></div>
      <button type="button" className={styles.avatarButton} onClick={goToActor} aria-label={`Open ${actorName}'s profile`}><UserAvatar user={item.actor} size={40} /></button>
      <div className={styles.activityContent}>
        <div className={styles.activityTopline}><button type="button" onClick={goToActor}>{actorName}</button><span>{item.createdAt || item.created_at ? moment(item.createdAt || item.created_at).fromNow() : "Recently"}</span></div>
        <div className={styles.activityTitle}>{item.title || "Learning activity"}</div>
        <Text className={styles.activitySubtitle}>{item.subtitle || "Updated learning activity"}</Text>
        {hasResource && <div className={styles.resourcePreview}>
          {item.thumbnail ? <img src={item.thumbnail} alt="" /> : <span className={styles.resourceFallback}><Icon icon="AiOutlineBook" size={18} /></span>}
          <div><strong>{metadata.title || item.title}</strong><span>{metadata.specialty || (item.object_type === "script" ? "Study resource" : item.object_type || "Learning update")}</span>{metadata.estimatedMinutes && <span>{metadata.estimatedMinutes} min read</span>}</div>
        </div>}
        {item.note && <div className={styles.activityNote}>“{item.note}”</div>}
        {action && <Button className={styles.activityAction} size="small" type="default" text={action.label} onClick={() => navigate(action.path)} />}
      </div>
    </article>
  );
};

export default FeedItem;
